// Deprecated
import "../dot-loading/dot-loading.css";
import { DotLoading } from '../dot-loading/dot-loading';
export default DotLoading;